/**
 * “Showing X–Y of Z results” above the results grid (Deakin pagination bar).
 */
import { useContext } from 'react';
import { SearchAppContext } from '../../context/search-app/search-app-context';

export const BASE_CLASS = 'pagination__results';

const SearchResultsSummary = () => {
  const { results, totalResults, page, pageSize, status } =
    useContext(SearchAppContext);

  if (status !== 'success' || totalResults === 0) {
    return (
      <p className={BASE_CLASS} aria-live="polite">
        {' '}
      </p>
    );
  }

  const safePageSize = Math.max(1, pageSize);
  const start = (page - 1) * safePageSize + 1;
  const end = Math.min(page * safePageSize, totalResults);

  return (
    <p className={BASE_CLASS} aria-live="polite">
      Showing {start}-{end} of {totalResults} results
    </p>
  );
};

export default SearchResultsSummary;
